// extracted by mini-css-extract-plugin
module.exports = {"badge":"NewCountBadge_badge__Jpp69"};